<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn flat to="/commercial" exact class="ma-0">  
            <v-icon color="grey lighten-1" class="mr-3">fas fa-angle-left</v-icon>
            <div class="headline">Gestion</div>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="test-xs-right">
        </v-flex>
        <v-flex xs12 lg6>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap align-center>
                <v-flex xs8>
                  <div class="headline">{{ indicateurGestion('lots') }} Lots</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <div class="subheading">
                    <color-indicator :formated-value="indicateurGestion('evolution') | percent(2)" :raw-value="indicateurGestion('evolution')"></color-indicator>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 lg6>
          <v-card>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <line-chart :data="chartData" :options="chartOptions"></line-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import LineChart from '@/components/charts/LineChart.js'
import { mapGetters } from 'vuex'

export default {
  name: 'Gestion',
  components: {
    LineChart
  },
  data() {
    return {
      agence : 'Toutes',
    }
  },
  computed: {
    ...mapGetters(['indicateurGestion', 'serieGestion']),
    chartData() {
      return {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: [
          {
            label: 'Nombres de lots',
            backgroundColor: '#E53935',
            data: this.serieGestion('lots')
          },
        ]
      }
    },
    chartOptions() {
      return {
        scales: {
          yAxes: [{
            ticks: {
              suggestedMin: this.indicateurGestion('lots') - 100,
              suggestedMax: this.indicateurGestion('lots') + 100
            }
          }]
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
